import React, { useEffect, useState } from "react";
import api from "../../Utils/Axios";
import { Link } from "react-router-dom";
import useChatNotifications from "../../hooks/useChatNotifications";

const AdminDashboard = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const { unreadCount } = useChatNotifications("admin");

  useEffect(() => {
    const run = async () => {
      try {
        const res = await api.get("/api/admin/dashboard", { timeout: 20000 });
        setData(res.data.dashboard);
        setError("");
      } catch (err) {
        if (err?.code === "ECONNABORTED") {
          setError("Dashboard request timed out. Please reload once backend is up.");
        } else {
          setError(err?.response?.data?.message || err?.message || "Failed to load dashboard");
        }
      } finally {
        setLoading(false);
      }
    };
    run();
  }, []);

  if (loading) return <div className="col-lg-12">Loading admin dashboard...</div>;
  if (error) return <div className="col-lg-12">{error}</div>;

  const cards = [
    { label: "Users", value: data?.usersCount || 0, route: "/admin-users", variant: "" },
    { label: "Hospitals", value: data?.hospitalsCount || 0, route: "/hospital-listing", variant: "two" },
    { label: "Pending Hospitals", value: data?.pendingHospitals || 0, route: "/hospital-listing", variant: "three" },
    { label: "Jobs", value: data?.jobsCount || 0, route: "/admin-jobs", variant: "four" },
    { label: "Blogs", value: data?.blogsCount || 0, route: "/admin-blogs", variant: "three" },
    { label: "Payments", value: data?.paymentsCount || 0, route: "/admin-payments", variant: "" },
    { label: "Revenue (USD)", value: `$${data?.totalRevenueUSD || 0}`, route: "/admin-payments", variant: "two" },
    { label: "Unread Chat", value: unreadCount, route: "/admin-chat", variant: "four" },
  ];

  return (
    <div className="col-lg-12">
      <div className="dashboard-inner">
        <div className="counter-area">
          <div className="row g-lg-4 g-md-5 gy-5 justify-content-center">
          {cards.map((item) => (
            <div className="col-lg-3 col-sm-6" key={item.label}>
              <div className={`counter-single ${item.variant}`.trim()}>
                <div className="coundown">
                  <p>{item.label}</p>
                  <h3>{item.value}</h3>
                  <Link to={item.route} className="primry-btn-1" style={{ marginTop: 8, display: "inline-block" }}>
                    Manage
                  </Link>
                </div>
              </div>
            </div>
          ))}
          </div>
        </div>

        <div className="row g-4 mt-4">
          <div className="col-lg-6">
            <div className="table-wrapper2">
              <div className="title-and-btn">
                <div className="title">
                  <h4>Recent Hospitals</h4>
                </div>
              </div>
              <table className="eg-table table job-list-table mb-0">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {(data?.recentHospitals || []).length === 0 ? (
                    <tr><td colSpan="3">No data</td></tr>
                  ) : (
                    (data?.recentHospitals || []).map((item) => (
                      <tr key={item._id}>
                        <td>{item.name}</td>
                        <td>{item.email}</td>
                        <td>{item.isVerified ? "Verified" : "Pending"}</td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="table-wrapper2">
              <div className="title-and-btn">
                <div className="title">
                  <h4>Recent Users</h4>
                </div>
              </div>
              <table className="eg-table table job-list-table mb-0">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Verified</th>
                  </tr>
                </thead>
                <tbody>
                  {(data?.recentUsers || []).length === 0 ? (
                    <tr><td colSpan="3">No data</td></tr>
                  ) : (
                    (data?.recentUsers || []).map((item) => (
                      <tr key={item._id}>
                        <td>{`${item.firstName || ""} ${item.lastName || ""}`.trim()}</td>
                        <td>{item.email}</td>
                        <td>{item.isEmailVerified ? "Yes" : "No"}</td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div className="row g-4 mt-1">
          <div className="col-lg-12">
            <div className="table-wrapper2">
              <div className="title-and-btn">
                <div className="title">
                  <h4>Recent Payments</h4>
                </div>
              </div>
              <table className="eg-table table job-list-table mb-0">
                <thead>
                  <tr>
                    <th>Purpose</th>
                    <th>Amount</th>
                    <th>Status</th>
                    <th>Date</th>
                  </tr>
                </thead>
                <tbody>
                  {(data?.recentPayments || []).length === 0 ? (
                    <tr><td colSpan="4">No payments yet.</td></tr>
                  ) : (
                    (data?.recentPayments || []).map((item) => (
                      <tr key={item._id}>
                        <td>{item.purpose || "general"}</td>
                        <td>${item.amount || 0}</td>
                        <td>{item.status}</td>
                        <td>{new Date(item.createdAt).toLocaleDateString()}</td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
